/**
 * UUID V4
 * 目前已测试800万次执行，重复率为0
 * @param [lowercase] {boolean} 是否小写，默认为大写
 */
export function uuid(lowercase) {
    if (lowercase === void 0) { lowercase = false; }
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
        var r = (Math.random() * 16) | 0;
        var result = (c === 'x' ? r : (r & 0x3) | 0x8).toString(16);
        return lowercase ? result : result.toUpperCase();
    });
}
